import { LegacyBox, LegacyText, styled } from '@gogame/components';

export const Container = styled(LegacyBox)`
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  flex-direction: column;
`;

export const Title = styled(LegacyText)`
  padding: 10px 0;
`;
